import React from 'react';
import PropTypes from 'prop-types';
import { ElementWithTooltip } from 'DesignSystem/Tooltips';
import RecipientPreviewEmptyStateTooltip from './RecipientPreviewEmptyStateTooltip';

const RecipientPreviewEmptyStateTextField = ({ targetElement }) => (
  <ElementWithTooltip
    className="self-serve-recipient-preview-empty-state-tooltip"
    placement="right"
    size="lg"
    showByDefault
    targetElement={targetElement}
    tooltipId="selfServeRecipientPreviewEmptyStateTooltip"
  >
    <RecipientPreviewEmptyStateTooltip />
  </ElementWithTooltip>
);

RecipientPreviewEmptyStateTextField.propTypes = {
  targetElement: PropTypes.node.isRequired,
};

export default RecipientPreviewEmptyStateTextField;



// WEBPACK FOOTER //
// ./src-react/SelfServeRecipientBuilder/components/RecipientPreviewEmptyStateTextField.jsx